<template>
  <div class="order-history">
    <h2 class="h4">{{ $T('title') }}</h2>
    <hr>

    <c-loader v-if="isLoading" inline scale="2.5" />
    <p v-else-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
    <p v-else-if="rows.length === 0">{{ $T('empty') }}</p>

    <b-table
             v-else
             small
             hover
             responsive
             :fields="fields"
             :items="rows"
             :busy="isLoading">
      <template #cell(orderNumber)="data">
        <a :href="getDetailUrl(data.item.orderNumber)">{{ data.item.orderNumber }}</a>
      </template>
      <template #cell(orderDate)="data">
        {{ data.item.orderDate | formatDateTime }}
      </template>
      <template #cell(totalPrice)="data">
        {{ formatPrice(data.item.totalPrice) }}
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'OrderHistory',
  props: {
    detailBaseUrl: {
      type: String,
      default: ''
    },
    translations: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isLoading: false,
      errorMessage: null,
      rows: []
    }
  },
  computed: {
    activeLocationId() {
      return this.$store.getters['profile/getActiveLocationId']
    },
    fields() {
      return [
        { key: 'orderNumber', label: this.$T('columnsOrderNumber') },
        { key: 'orderDate', label: this.$T('columnsOrderDate') },
        { key: 'orderState', label: this.$T('columnsOrderState') },
        { key: 'totalPrice', label: this.$T('columnsTotalPrice'), class: 'text-right' }
      ]
    }
  },
  methods: {
    getDetailUrl(orderNumber) {
      if (!this.detailBaseUrl || orderNumber == null || orderNumber === '') return '#'
      return `${this.detailBaseUrl.replace(/\/$/, '')}/${encodeURIComponent(String(orderNumber))}`
    },
    formatPrice(value) {
      const number = Number(value || 0)
      return number.toLocaleString(this.$i18n.locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    loadHistory() {
      if (!this.activeLocationId) {
        this.rows = []
        return
      }

      this.isLoading = true
      this.errorMessage = null

      this.$http({
        method: 'post',
        url: 'searchnext/api/search/order/query',
        data: {
          language: this.$store.getters['gui/getLanguage'],
          sort: [{ name: 'OrderDate', type: 'string', isDescending: true }],
          page: 1,
          pageSize: 50
        }
      })
        .then((response) => {
          const result = response?.data?.result || []
          this.rows = result.map((item) => ({
            orderNumber: item.ordernumber || '',
            orderDate: item.orderdate || null,
            orderState: (item.orderstate_label && item.orderstate_label[this.$i18n.locale]) || item.orderstate || '',
            totalPrice: item.totalprice || 0
          }))
        })
        .catch(() => {
          this.errorMessage = this.$T('loadError')
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  created() {
    this.loadHistory()
  }
}
</script>
